var map = {
	"./logo.png": 31362,
	"./logo.svg": 88394,
	"./logo_safecall_go.png": 24653,
	"./logo_safecall_go_login.png": 32726,
	"./logo_safecall_pro.png": 38749,
	"./logo_safecall_pro_login.png": 85234,
	"./logogo.png": 30604,
	"./logogologin.png": 26547,
	"./logopro.png": 39290,
	"./logoprologin.png": 60951,
	"./logoproold.png": 64693,
	"./logosignup.png": 9627,
	"./safecall-logo.png": 21040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63415;